export const resolveLocalizedText = (value, language = 'es', fallback = 'es') => {
  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'object' && !Array.isArray(value)) {
    const candidate = value[language] ?? value[fallback];
    if (typeof candidate === 'string' || typeof candidate === 'number') {
      return String(candidate);
    }

    const firstString = Object.values(value).find((item) => typeof item === 'string' || typeof item === 'number');
    return firstString ? String(firstString) : '';
  }

  return '';
};

export const resolveLocalizedList = (value, language = 'es', fallback = 'es') => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === 'object') {
    const candidate = value[language] ?? value[fallback];
    if (Array.isArray(candidate)) {
      return candidate;
    }

    const firstList = Object.values(value).find(Array.isArray);
    return firstList || [];
  }

  return [];
};

const normalizeServiceKey = (value) => {
  if (!value) return '';
  return String(value)
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
};

const serviceTranslations = {
  wifi: { en: 'WiFi' },
  'wi-fi': { en: 'WiFi' },
  'wi-fi rapido': { en: 'Fast WiFi' },
  piscina: { en: 'Pool' },
  'piscina privada': { en: 'Private pool' },
  'piscina climatizada': { en: 'Heated pool' },
  'aire acondicionado': { en: 'Air conditioning' },
  calefaccion: { en: 'Heating' },
  cocina: { en: 'Kitchen' },
  'cocina equipada': { en: 'Fully equipped kitchen' },
  nevera: { en: 'Fridge' },
  microondas: { en: 'Microwave' },
  horno: { en: 'Oven' },
  lavavajillas: { en: 'Dishwasher' },
  cafetera: { en: 'Coffee maker' },
  lavadora: { en: 'Washing machine' },
  secadora: { en: 'Dryer' },
  plancha: { en: 'Iron' },
  'secador de pelo': { en: 'Hair dryer' },
  tv: { en: 'TV' },
  'smart tv': { en: 'Smart TV' },
  'parking gratuito': { en: 'Free parking' },
  jacuzzi: { en: 'Hot tub' },
  gimnasio: { en: 'Gym' },
  sauna: { en: 'Sauna' },
  'terraza/balcon': { en: 'Terrace/Balcony' },
  jardin: { en: 'Garden' },
  barbacoa: { en: 'Barbecue' },
  'patio exterior': { en: 'Outdoor patio' },
  'vistas al mar': { en: 'Sea views' },
  'primera linea de playa': { en: 'Beachfront' },
  cuna: { en: 'Crib' },
  'trona para bebe': { en: 'High chair' },
  'zona de trabajo': { en: 'Workspace' },
  chimenea: { en: 'Fireplace' },
  ascensor: { en: 'Elevator' },
  'acceso sin escaleras': { en: 'Step-free access' },
  'check-in autonomo': { en: 'Self check-in' },
  'ropa de cama': { en: 'Bed linen' },
  toallas: { en: 'Towels' },
  'admite mascotas': { en: 'Pets allowed' },
  'limpieza incluida': { en: 'Cleaning included' },
};

export const translateServiceLabel = (service, language = 'es') => {
  if (language === 'es') {
    return service;
  }

  const normalized = normalizeServiceKey(service);
  return serviceTranslations[normalized]?.[language] || service;
};
